export const CONFIG = {
  API_TIMEOUT_MS: 30_000,
  DEBOUNCE_DELAY_MS: 300,
  AUTOSAVE_DELAY_MS: 2_000,
  NOTIFICATION_AUTO_HIDE_MS: 5_000,
  CACHE_DURATION_MS: 5 * 60 * 1_000,
  MAX_HOURS_PER_DAY: 24,
  QUARTER_HOUR_INCREMENT: 0.25,
  QUARTER_HOUR_MS: 15 * 60 * 1_000,
  DAYS_IN_WEEK: 7,
  MAX_WEEKS_IN_YEAR: 53,
  PAGINATION_DEFAULT_SIZE: 100,
  PAGINATION_MAX_SIZE: 100,
  DARK_MODE_STORAGE_KEY: 'twr_dark_mode',
  SECONDS_PER_HOUR: 3_600,
  SECONDS_PER_MINUTE: 60,
  DAY_TARGET_HOURS: 8,
  WEEK_WORKING_DAYS: 5,
  PROGRESS_HIGH_THRESHOLD: 0.8,
  PROGRESS_MEDIUM_THRESHOLD: 0.5,
  SAVE_STATUS_DURATION_MS: 3_000,
  PAGINATION_MEDIUM_SIZE: 50,
  YEAR_RANGE_SIZE: 5,
  YEAR_RANGE_OFFSET: 2,
  MAX_MONTHLY_WORKING_HOURS: 250,
  MAX_WORKING_DAYS_PER_MONTH: 31,
  SHORTCUT_SEQUENCE_TIMEOUT_MS: 500,
  AD_SEARCH_MIN_LENGTH: 2,
} as const;
